import React from 'react';
import './notFoundPage.css';

const NotFound = () => {

  return (

    
    <div className="container">
      <div className="row">
        <div className="col-md-12">
            <h4>Page Not Found</h4>
        </div>
      </div>
    </div>
     
    
  );
};

export default NotFound;
